/*
 *  -----------------------------------------------------------------------
 *    <copyright file="notification.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { Subject, Observable } from 'rxjs';

const subject = new Subject();

/*
    The message object can either be a string
    or object with text as string and type as string
    if message is a string, it would display the message with style none
    if the message is an object, it would take the type from the type field.
    implementation is in App.tsx
    Examples
        object : NotificationService.showNotification({ text: t('errorMessage'), type: 'error' })
        string : NotificationService.showNotification(t('common:actionsSuccessfulToast'));
 */

export type MessageType = 'none' | 'success' | 'error' | 'warning' | 'info';

interface MessageParams {
    text: string;
    type: MessageType;
}

export const ShowMessage = (message: MessageParams) => {
    NotificationService.showNotification(message);
};

export const ShowError = (text: string) => ShowMessage({ text, type: 'error' });
export const ShowSuccess = (text: string) => ShowMessage({ text, type: 'success' });
export const ShowWarning = (text: string) => ShowMessage({ text, type: 'warning' });

const NotificationService = {
    showNotification: (message: any) => {
        subject.next(message);
    },
    onUpdateNotification(): Observable<any> {
        return subject.asObservable();
    },
};

export default NotificationService;
